<template>
  <div>
    <!-- Committee list -->
    <div>
      <vs-table
        id="committee-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['committee_create'])"
              @click="addPage"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>

            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Committee Name</vs-th>
          <vs-th>Country</vs-th>
          <vs-th>State</vs-th>
          <vs-th>City</vs-th>
          <vs-th v-if="checkPermissionSlug(['committee_edit'])" sort-key="status">Visible</vs-th>
          <vs-th v-if="checkPermissionSlug(['committee_delete']) || checkPermissionSlug(['committee_invite_committee']) || checkPermissionSlug(['committee_edit'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer" v-if="checkPermissionSlug(['committee_edit'])" @click.stop="toggleEditCommittee(tr._id, $event)" v-tooltip="{ content: `Edit ${tr.name}` }">{{
                tr.name || '-'
              }}</span>
              <span v-else>{{ tr.name || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.country ? tr.country.country_name : '-' }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.state ? tr.state.name : '-' }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.city ? tr.city.name : '-' }}</p>
            </vs-td>
            <vs-td v-if="checkPermissionSlug(['committee_edit'])">
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td>

            <vs-td v-if="checkPermissionSlug(['committee_delete', 'committee_invite_committee', 'committee_edit'])">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                  Actions
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu class="locations__actions w-1/6">
                  <vs-dropdown-item v-if="checkPermissionSlug(['committee_invite_committee']) && !tr.admin" @click.stop="inviteMember(tr._id)">
                    <feather-icon icon="SendIcon" svgClasses="h-5 w-5  mr-4 hover:text-primary cursor-pointer" /> Invite Committee Admin
                  </vs-dropdown-item>
                  <vs-dropdown-item @click.stop="viewAccessUsers(tr._id)">
                    <feather-icon icon="LockIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> {{ module_name }} Accees Users
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionSlug(['committee_edit'])" @click.stop="toggleEditCommittee(tr._id, $event)">
                    <feather-icon icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Edit Committee
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkPermissionSlug(['committee_delete'])" @click.stop="deleteRecord(tr._id)">
                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" /> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive" :title="`Invite Committee Admin`" class="small_modal">
        <div class="vx-row px-5 vs-con-loading__container">
          <div class="vx-col px-0 w-full">
            <div class="mt-2 mb-3">
              <label class="vs-input--label">Mail *</label>
              <vs-input id="Email" class="w-full" v-model="form.email" v-validate="'required|min:1|email'" name="Email" icon="icon icon-mail" icon-pack="feather" placeholder="Please add Email" />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
            </div>
            <div class="mt-4">
              <div class="w-full px-0 justify-items-center">
                <vs-button class="text-sm py-3 px-5" color="dark" @click="inviteMember()"> Cancel </vs-button>
                <vs-button
                  id="invite-committee"
                  class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                  @click="inviteCommitteeAdmin"
                  type="submit"
                  >Invite</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'CommitteeList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Committee',
    route_slug: 'committee',
    form: {
      email: '',
      committee: ''
    },
    popupActive: false
  }),

  /** computed */
  computed: {
    ...mapState('committee', ['records', 'total', 'FilteredCount', 'listLoading', 'createLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('committee', {
      get: 'get',
      delete: 'delete',
      inviteAdmin: 'inviteAdmin'
    }),

    /** Invite Member */
    inviteMember(id) {
      this.form.committee = id
      if (this.popupActive) {
        this.popupActive = false
      } else {
        this.popupActive = true
      }
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Committee List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    /** Navigate Add Committe page */
    addPage() {
      this.$router.push(`/${this.route_slug}/add`)
    },

    /** Navigate Edit Committe page */
    toggleEditCommittee(id, event) {
      const editUrl = `/${this.route_slug}/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    /** Committee Access Users List */
    viewAccessUsers(id) {
      this.$router.push(`/${this.route_slug}/${id}/access-users`)
    },

    /** Delete Committee Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Committee API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('committee/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    },

    /** Invite Admin */
    async inviteCommitteeAdmin() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const { message } = await this.inviteAdmin(this.form)
        this.form = {}
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.popupActive = false
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#committee-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#committee-list > .con-vs-loading')
      }
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#invite-committee',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#invite-committee > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
